<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('conversations')"
      :columns="columns"
      :column_search="true"
      resource_url="/assistant/conversation/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <conversation-modal ref="conversation_modal" @success="refresh" />
  <socket-conversation-modal
    ref="socket_conversation_modal"
    @success="refresh"
  />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  format_date_time,
  del,
  error_message,
  format_currency,
} from "@/utils";
import ConversationModal from "./conversation_modal/Index.vue";
import SocketConversationModal from "./socket_conversation_modal/Index.vue";

export default {
  name: "ConversationDatatable",
  components: { GenericTable, ConversationModal, SocketConversationModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          data: (row) => {
            return format_date_time(row.create_date);
          },
        },
        {
          title: v.$t("personality"),
          data: (row) => {
            return row.personality.name || "";
          },
        },
        // {
        //   title: v.$t("name"),
        //   name: "name",
        //   data: (row) => {
        //     return row.uuid || "";
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: true,
        //   width: "80%",
        //   data: (row) => {
        //     // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     return `<div class="content"><ul>
        //       <li>${row.prompt}</li>
        //       <li>${row.response}</li>
        //     </ul></div>`;
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.socket_conversation_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete conversation?"),
                    v,
                    () => {
                      del("/assistant/conversation", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      // v.$refs.conversation_modal.show_modal();
      v.$refs.socket_conversation_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
